import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import ContentWrapper from '../styles/ContentWrapper';

const Tos = () => {
    const StyledThing = styled.article`

    `;

    return (
        <React.Fragment>
            <Helmet>
                <meta name="robots" content="noindex, nofollow"/>
            </Helmet>
            <article role="article" about="/legal/agb" typeof="schema:WebPage">
                <ContentWrapper>
                    <span
                        property="schema:name"
                        content="Terms and Conditions"
                        className="stolo-hidden"
                    />
                    <div>
                        <h1>General Terms and Conditions with Customer Information</h1>
                        <h2>Table of Contents</h2>
                        <ol>
                            <li>Scope of application</li>
                            <li>Conclusion of the contract</li>
                            <li>Right of withdrawal</li>
                            <li>Prices and payment terms</li>
                            <li>Delivery and shipping terms</li>
                            <li>Granting of usage rights for digital content</li>
                            <li>Retention of title</li>
                            <li>Liability for defects (warranty)</li>
                            <li>Liability</li>
                            <li>Special terms for the processing of goods according to
                                particular specifications of the customer
                            </li>
                            <li>Redemption of promotional vouchers</li>
                            <li>Redemption of gift vouchers</li>
                            <li>Applicable law</li>
                            <li>Place of jurisdiction</li>
                            <li>Alternative dispute resolution</li>
                        </ol>
                        <h2>1) Scope of application</h2>
                        <p><b>1.1</b>&nbsp;These General Terms and Conditions
                            (hereinafter &quot;T&amp;Cs&quot;) of Becker &amp; Karsten UG
                            (haftungsbeschr&auml;nkt) (hereinafter &quot;we/us&quot;) apply to
                            all contracts for the supply of goods that you, as a consumer or
                            entrepreneur (hereinafter &bdquo;you&#8220;), conclude with us with
                            regard to the goods presented in our online shop. We hereby
                            object to the inclusion of your own terms, unless we have
                            agreed otherwise with you.</p>
                        <p><b>1.2</b>&nbsp;For contracts for the supply of vouchers, these
                            T&amp;Cs apply accordingly, unless otherwise stipulated in this
                            respect.</p>
                        <p><b>1.3</b>&nbsp;For contracts for the provision of digital
                            content, these T&amp;Cs apply accordingly, unless otherwise
                            stipulated in this respect. Digital content within the meaning of these T&amp;Cs is data
                            that is created and provided in digital form.</p>
                        <p><b>1.4</b>&nbsp;You are a consumer within the meaning of these T&amp;Cs if you conclude a
                            legal transaction for purposes that can predominantly be attributed neither to your
                            commercial nor to your self-employed professional
                            activity.</p>
                        <p><b>1.5</b>&nbsp;You are an entrepreneur within the meaning of these T&amp;Cs if, as a natural
                            or legal person or as a partnership with legal capacity, you are
                            acting in the exercise of your commercial or self-employed professional activity when
                            concluding a legal transaction.</p>
                        <h2>2) Conclusion of the contract</h2>
                        <p><b>2.1</b>&nbsp;The product descriptions contained in our online shop
                            do not constitute binding offers on our part,
                            but rather serve to enable you to submit a binding offer.</p>
                        <p><b>2.2</b>&nbsp;You can submit the offer via the online order form
                            integrated into our online shop. In doing so, after placing the
                            selected goods in the virtual shopping cart and completing the
                            electronic ordering process, you submit a legally binding
                            contractual offer with regard to the goods contained in the shopping cart
                            by clicking the button that concludes the ordering process.</p>
                        <p><b>2.3</b>&nbsp;We can accept your offer within five days,</p>
                        <ul>
                            <li>by sending you a written order confirmation or an
                                order confirmation in text form (fax or e-mail), whereby in this respect
                                the receipt of the order confirmation by you is
                                decisive, or
                            </li>
                            <li>by delivering the ordered goods to you, whereby in this respect the receipt of the
                                goods by you is decisive, or
                            </li>
                            <li>by requesting payment from you after you have submitted your order.
                            </li>
                        </ul>
                        <p>If several of the aforementioned alternatives apply, the contract is concluded at the
                            point in time at which one of the aforementioned alternatives first
                            occurs. The period for accepting your offer begins on the day after the
                            dispatch of your offer and ends at the end of the fifth day
                            following the dispatch of the offer. If we do not accept your offer
                            within the aforementioned period, this is deemed a rejection of the
                            offer, with the consequence that you are no longer bound by your declaration of intent.</p>
                        <p><b>2.4</b>&nbsp;If you select a payment method offered by PayPal,
                            payment processing is carried out via the payment service provider PayPal
                            (Europe) S.&agrave; r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449
                            Luxemburg (hereinafter: &bdquo;PayPal&#8220;), subject to the
                            PayPal Terms of Use, available at <a
                                href="https://www.paypal.com/de/legalhub/paypal/useragreement-full"
                                target="_blank">https://www.paypal.com/de/legalhub/paypal/useragreement-full
                            </a> or &ndash; if you do not have a PayPal account
                            &ndash; subject to the terms for payments without a
                            PayPal account, available at <a
                                href="https://www.paypal.com/de/legalhub/paypal/privacywax-full"
                                target="_blank">https://www.paypal.com/de/legalhub/paypal/privacywax-full</a>.
                            If you pay by means of a payment method offered by PayPal and selectable
                            in the online ordering process, we already now declare the acceptance
                            of your offer at the point in time at which you click the button that
                            concludes the ordering process.
                        </p>
                        <p><b>2.5</b>&nbsp;When ordering via our online order form,
                            we store the contract text after the conclusion of the contract and send
                            it to you in text form (e.g. e-mail, fax or
                            letter) after you have dispatched your order. We do not make the
                            contract text accessible beyond this. If, prior to dispatching your
                            order, you have set up a user account in our online shop,
                            your order data is archived on our website and can be
                            retrieved by you free of charge via your password-protected user account by providing the
                            corresponding login data.</p>
                        <p><b>2.6</b>&nbsp;Before bindingly submitting the order via our
                            online order form, you can identify possible input errors by
                            carefully reading the information displayed on the screen.
                            An effective technical means for better recognition of
                            input errors can be the zoom function of your
                            browser, with the help of which the display on the screen is
                            enlarged. You can correct your entries within the
                            electronic ordering process using the usual
                            keyboard and mouse functions until you click the button that
                            concludes the ordering process.</p>
                        <p><b>2.7</b>&nbsp;Different languages are available to you for the
                            conclusion of the contract. The specific choice of language is displayed in the online shop.</p>
                        <p><b>2.8</b>&nbsp;Order processing and contact generally take place
                            by e-mail and automated order processing. You must
                            ensure that the e-mail address you provide for order processing is
                            correct, so that the e-mails we send can be received at this address.
                            In particular, when using SPAM filters, you must ensure that all e-mails sent by us or by third parties
                            commissioned by us with order processing can be
                            delivered.</p>
                        <h2>3) Right of withdrawal</h2>
                        <p><b>3.1</b>&nbsp;Consumers are generally entitled to a right of withdrawal.</p>
                        <p><b>3.2</b>&nbsp;Further information on the right of withdrawal can be found
                            in our withdrawal policy (Widerrufsbelehrung).</p>
                        <p><b>3.3</b>&nbsp;The right of withdrawal does not apply to consumers who, at the
                            time of the conclusion of the contract, do not belong to any member state of the European
                            Union and whose sole place of residence and delivery address at the
                            time of the conclusion of the contract are outside the European Union.</p>
                        <h2>4) Prices and payment terms</h2>
                        <p><b>4.1</b>&nbsp;Unless otherwise stated in our product description,
                            the prices indicated are total prices that include
                            the statutory value added tax. Any additional
                            delivery and shipping costs that may apply are stated separately in the respective
                            product description.</p>
                        <p><b>4.2</b>&nbsp;In the case of deliveries to countries outside the
                            European Union, additional costs may arise in individual cases
                            that we are not responsible for and that are to be borne by you. These
                            include, for example, costs for the transfer of money by
                            credit institutions (e.g. transfer fees,
                            exchange rate fees) or import duties or taxes (e.g.
                            customs duties). Such costs may also arise with regard to the
                            transfer of money even if the delivery is not made to a
                            country outside the European Union, but you make the payment
                            from a country outside the European Union.</p>
                        <p><b>4.3</b>&nbsp;The payment option(s) available to you will be communicated to you in our
                            online shop.</p>
                        <p><b>4.4</b>&nbsp;If payment in advance by bank transfer is agreed,
                            payment is due immediately after conclusion of the contract, unless we have
                            agreed a later due date with you.</p>
                        <p><b>4.5</b>&nbsp;If you select a payment method offered via the
                            payment service &quot;Shopify Payments&quot;, payment processing is carried out
                            by the payment service provider Stripe Payments
                            Europe Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Irland
                            (hereinafter &quot;Stripe&quot;). The individual payment methods offered via Shopify Payments
                            will be communicated to you in our online shop. To
                            process payments, Stripe may use further payment services
                            for which special payment terms may apply, to which you may be
                            separately referred. Further information on &quot;Shopify
                            Payments&quot; is available on the internet at <a
                                href="https://www.shopify.com/legal/terms-payments-de"
                                target="_blank">https://www.shopify.com/legal/terms-payments-de</a>.
                        </p>
                        <p><b>4.6</b>&nbsp;If you select a payment method offered via the
                            payment service &bdquo;Stripe&#8220;, payment processing is carried out
                            via the payment service provider Stripe Payments
                            Europe Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Irland
                            (hereinafter &quot;Stripe&quot;). The individual payment methods offered via Stripe
                            will be communicated to you in our online shop. To process
                            payments, Stripe may use further payment services
                            for which special payment terms may apply, to which you may be separately
                            referred. Further information on Stripe is available on the internet at <a
                                href="https://stripe.com/de"
                                target="_blank">https://stripe.com/de</a>.
                        </p>
                        <h2>5) Delivery and shipping terms</h2>
                        <p><b>5.1</b>&nbsp;If we offer to ship the goods, delivery
                            takes place within the delivery area we specify to the
                            delivery address you specify, unless otherwise agreed. In the
                            processing of the transaction, the delivery address specified in our order processing is
                            decisive.</p>
                        <p><b>5.2</b>&nbsp;If delivery of the goods fails for reasons for which you
                            are responsible, you bear the reasonable costs incurred by us as a result.
                            This does not apply with regard to the costs for the
                            outbound shipment if you effectively exercise your right of withdrawal. With regard to
                            the return shipping costs, in the event of an effective exercise of the
                            right of withdrawal by you, the provision set out in our withdrawal policy in this respect
                            applies.</p>
                        <p><b>5.3</b>&nbsp;If you are acting as an entrepreneur, the risk of
                            accidental loss and accidental deterioration of the
                            sold goods passes to you as soon as we have delivered the item to the carrier, the
                            freight forwarder or the person or institution otherwise designated to carry out the shipment.
                            If you are acting as a
                            consumer, the risk of accidental loss and
                            accidental deterioration of the sold goods generally passes
                            only upon handover of the goods to you or to a person authorized to receive them.
                            Notwithstanding this, the risk of accidental
                            loss and accidental deterioration of the sold goods, even
                            if you are acting as a consumer, passes to you as soon as we have delivered the
                            item to the carrier, the freight forwarder or the person or institution otherwise designated to carry out the shipment,
                            if you have commissioned the carrier, the freight forwarder or the person or institution otherwise designated to carry out the shipment
                            with the
                            execution and we have not previously named this person or institution
                            to you.</p>
                        <p><b>5.4</b>&nbsp;We reserve the right to withdraw from the contract in the event of incorrect
                            or improper delivery to us. This applies only in the case that the
                            non-delivery is not our responsibility and we have concluded a specific covering
                            transaction with the supplier with the requisite
                            care. We will make all reasonable efforts to
                            procure the goods. In the event of non-availability or only
                            partial availability of the goods, you will be informed without delay
                            and the consideration will be refunded to you without delay.</p>
                        <p><b>5.5</b>&nbsp;Collection in person is not possible for logistical reasons.</p>
                        <p><b>5.6</b>&nbsp;Vouchers are provided to you as follows:</p>
                        <ul>
                            <li>by e-mail</li>
                            <li>by post</li>
                        </ul>
                        <p><b>5.7</b>&nbsp;Digital content is provided to you as follows:</p>
                        <p>- by download</p>
                        <h2>6) Granting of usage rights for digital content</h2>
                        <p><b>6.1</b>&nbsp;Unless otherwise stated in the content description in our
                            online shop, we grant you the non-exclusive right, unlimited in terms of place and
                            time, to use the provided content for private as well as for
                            commercial purposes.</p>
                        <p><b>6.2</b>&nbsp;Passing on the content to third parties or creating
                            copies for third parties outside the scope of these T&amp;Cs is not
                            permitted, unless we have consented to a transfer of the
                            license that is the subject of the contract to the third party.</p>
                        <p><b>6.3</b>&nbsp;Insofar as the contract relates to the one-time provision
                            of a digital content, the granting of rights only becomes
                            effective once you have paid the contractually owed remuneration in full.
                            We may also provisionally permit use of the
                            content that is the subject of the contract before this point in time.
                            No transfer of rights takes place through such a
                            provisional permission.</p>
                        <h2>7) Retention of title</h2>
                        <p>If we perform in advance, we retain title to the delivered goods until
                            full payment of the purchase price owed.</p>
                        <h2>8) Liability for defects (warranty)</h2>
                        <p>Unless otherwise stated in the following provisions, the
                            provisions of statutory liability for defects apply. Deviating from this,
                            the following applies to contracts for the supply of goods:</p>
                        <p><b>8.1</b>&nbsp;If you are acting as an entrepreneur,</p>
                        <ul>
                            <li>we have the choice of the type of subsequent performance;</li>
                            <li>for new goods, the limitation period for
                                claims based on defects is one year from delivery of the goods;
                            </li>
                            <li>for used goods, claims based on defects are excluded;</li>
                            <li>the limitation period does not begin anew if a
                                replacement delivery is made within the scope of liability for defects.
                            </li>
                        </ul>
                        <p><b>8.2</b>&nbsp;The limitations of liability and
                            reductions of periods set out above do not apply</p>
                        <ul>
                            <li>to your claims for damages and reimbursement of expenses,</li>
                            <li>in the event that we have fraudulently concealed the defect,
                            </li>
                            <li>for goods that have been used for a building in accordance with their
                                customary use and have caused its
                                defectiveness,
                            </li>
                            <li>to any obligation we may have to provide
                                updates for digital products, in the case of contracts for the
                                supply of goods with digital elements.
                            </li>
                        </ul>
                        <p><b>8.3</b>&nbsp;In addition, for entrepreneurs the
                            statutory limitation periods for any statutory
                            right of recourse remain unaffected.</p>
                        <p><b>8.4</b>&nbsp;If you are acting as a merchant within the meaning of &sect; 1 HGB (German Commercial Code), the
                            commercial duty to examine and give notice of defects pursuant to &sect; 377 HGB applies to you.
                            If you fail to give the notices regulated there, the goods are deemed approved.</p>
                        <p><b>8.5</b>&nbsp;If you are acting as a consumer, you are requested to
                            report delivered goods with obvious transport damage to the
                            deliverer and to inform us of this. If you fail to do
                            so, this has no effect whatsoever on your statutory or
                            contractual claims based on defects.</p>
                        <h2>9) Liability</h2>
                        <p>The seller is liable to you for all contractual,
                            quasi-contractual and statutory claims, including claims in tort,
                            for damages and reimbursement of expenses as follows:</p>
                        <p><b>9.1</b>&nbsp;We are liable without limitation on any legal ground</p>
                        <ul>
                            <li>in the case of intent or gross negligence,</li>
                            <li>in the case of intentional or negligent injury to life,
                                body or health,
                            </li>
                            <li>on the basis of a guarantee promise, unless otherwise regulated in this respect,
                            </li>
                            <li>on the basis of mandatory liability such as under the Product Liability Act.
                            </li>
                        </ul>
                        <p><b>9.2</b>&nbsp;If we negligently breach a material contractual obligation,
                            liability is limited to the foreseeable damage typical for the contract,
                            unless we are liable without limitation pursuant to the preceding paragraph.
                            Material contractual obligations are obligations that
                            the contract imposes on us according to its content for the achievement of the purpose of the contract,
                            the fulfillment of which makes the proper performance of the contract possible in the first place and
                            on the observance of which you may regularly rely.</p>
                        <p><b>9.3</b>&nbsp;Otherwise, our liability is excluded.
                        </p>
                        <p><b>9.4</b>&nbsp;The above liability provisions also apply with regard to
                            our liability for our vicarious agents and legal
                            representatives.</p>
                        <h2>10) Special terms for the processing of goods according to
                            particular specifications of the customer</h2>
                        <p><b>10.1</b>&nbsp;If, according to the content of the contract, we owe in addition to the
                            supply of goods also the processing of the goods according to particular specifications of
                            you, you must provide us with all content required for the processing, such as
                            texts, images or graphics, in the file formats,
                            formatting, image and file sizes specified by us, and grant us the usage rights required for this.
                            You alone are responsible for the procurement of and acquisition of rights to these
                            content. You declare and assume
                            responsibility that you possess the right to use the
                            content provided to us. In particular, you ensure
                            that no rights of third parties are infringed thereby,
                            in particular copyrights, trademark rights and personality rights.</p>
                        <p><b>10.2</b>&nbsp;You indemnify us against claims of third parties that they
                            may assert in connection with an infringement of their rights through our
                            contractual use of the content provided to us by you.
                            In doing so, you also assume the necessary costs of legal defense,
                            including all court and attorney costs in the statutory
                            amount. This does not apply if the infringement is not your
                            responsibility. In the event of a claim by third parties, you are obliged to
                            provide us without delay, truthfully and
                            completely with all information required for the examination of the claims and a defense.</p>
                        <p><b>10.3</b>&nbsp;We reserve the right to refuse processing orders
                            if the content provided to us by you for this purpose violates
                            statutory or official prohibitions or public morals.
                            This applies in particular to the provision of
                            unconstitutional, racist, xenophobic,
                            discriminatory, insulting, youth-endangering and/or
                            violence-glorifying content.</p>
                        <h2>11) Redemption of promotional vouchers</h2>
                        <p><b>11.1</b>&nbsp;Vouchers that we issue free of charge within the scope of promotional campaigns with a
                            specific period of validity and that you cannot purchase (hereinafter &quot;promotional vouchers&quot;)
                            can only be redeemed in our online shop and only within the specified period.</p>
                        <p><b>11.2</b>&nbsp;Individual products may be excluded from the voucher campaign
                            if a corresponding restriction results from the
                            content of your promotional voucher.</p>
                        <p><b>11.3</b>&nbsp;Promotional vouchers can only be redeemed before the conclusion of the
                            ordering process. Subsequent offsetting
                            is not possible.</p>
                        <p><b>11.4</b>&nbsp;Only one promotional voucher can be redeemed by you per order.</p>
                        <p><b>11.5</b>&nbsp;Insofar as our promotional voucher relates to a specific
                            value and not to a percentage discount, your goods value
                            must correspond at least to the amount of the promotional voucher. Any
                            remaining balance is not refunded by us.</p>
                        <p><b>11.6</b>&nbsp;If the value of the promotional voucher is not sufficient to cover your
                            order, you can choose one of the other payment methods offered by us to
                            settle the difference.</p>
                        <p><b>11.7</b>&nbsp;The balance of a promotional voucher is neither paid out in cash
                            nor does it bear interest.</p>
                        <p><b>11.8</b>&nbsp;The promotional voucher is not refunded if you return the goods paid for
                            in whole or in part with the promotional voucher within the scope of your
                            statutory right of withdrawal.</p>
                        <p><b>11.9</b>&nbsp;The promotional voucher is transferable. We can render performance with
                            discharging effect to the respective holder who redeems the promotional voucher
                            in our online shop. This does not apply if we have
                            knowledge or grossly negligent ignorance of the lack of entitlement,
                            the legal incapacity or the lack of
                            power of representation of the respective holder.</p>
                        <h2>12) Redemption of gift vouchers</h2>
                        <p><b>12.1</b>&nbsp;Vouchers that can be purchased via our online shop
                            (hereinafter &quot;gift vouchers&quot;) can only be redeemed in our
                            online shop, unless otherwise stated in the voucher.</p>
                        <p><b>12.2</b>&nbsp;Gift vouchers and remaining balances of
                            gift vouchers can be redeemed until the end of the third year after the year of
                            the voucher purchase. Remaining balances are credited to you until the expiry date.</p>
                        <p><b>12.3</b>&nbsp;Gift vouchers can only be redeemed before the conclusion of the
                            ordering process. Subsequent offsetting
                            is not possible.</p>
                        <p><b>12.4</b>&nbsp;Gift vouchers can only be used for the purchase of
                            goods and not for the purchase of further gift vouchers.</p>
                        <p><b>12.5</b>&nbsp;If the value of the gift voucher is not sufficient to cover the
                            order, one of the other payment methods offered by us can be chosen to settle the difference.</p>
                        <p><b>12.6</b>&nbsp;The balance of a gift voucher is neither paid out in
                            cash nor does it bear interest.</p>
                        <p><b>12.7</b>&nbsp;The gift voucher is transferable. The
                            seller can render performance with discharging effect to the respective holder who
                            redeems the gift voucher in the seller's online shop. This does not apply if the seller has knowledge or grossly
                            negligent ignorance of the lack of entitlement, the
                            legal incapacity or the lack of power of representation
                            of the respective holder.</p>
                        <h2>13) Applicable law</h2>
                        <p><b>13.1</b>&nbsp;The law of the Federal Republic of Germany applies to all
                            legal relationships between us, to the exclusion of the
                            laws on the international sale of movable goods. If you are acting as a
                            consumer, this choice of law applies only insofar as the
                            protection granted to you by mandatory provisions of the law of the state in which you have your
                            habitual residence is not thereby withdrawn.</p>
                        <p><b>13.2</b>&nbsp;Furthermore, this choice of law does not apply with regard to the
                            statutory right of withdrawal in the case of consumers who, at the time of the
                            conclusion of the contract, do not belong to any member state of the European Union
                            and whose sole place of residence and delivery address at the time
                            of the conclusion of the contract are outside the European Union.
                        </p>
                        <h2>14) Place of jurisdiction</h2>
                        <p>If you are acting as a merchant, a legal person under public law
                            or a special fund under public law domiciled in the
                            territory of the Federal Republic of Germany, the exclusive
                            place of jurisdiction for all disputes arising from this contract is our
                            place of business. If your domicile is outside the territory
                            of the Federal Republic of Germany, then our place of business is
                            the exclusive place of jurisdiction for all disputes arising from this
                            contract if the contract or claims arising from the contract can be attributed to your
                            professional or commercial activity.
                            In the aforementioned cases, however, we are in any case
                            entitled to take legal action at the court of your domicile.</p>
                        <h2>15) Alternative dispute resolution</h2>
                        <p>We are not obliged to participate in a dispute resolution procedure before a
                            consumer arbitration board, but are willing to do so.</p>
                    </div>

                    <div id="widerruf">
                        <h1>Cancellation Policy &amp; Cancellation Form</h1>
                        <h2>A. Cancellation Policy</h2>
                        <h3>Introduction</h3>
                        <p>Consumers have a right of withdrawal subject to the following provisions,
                            whereby
                            a consumer is any natural person who concludes a legal transaction for
                            purposes that can predominantly be attributed neither to their commercial
                            nor to their independent professional
                            activity:</p>
                        <h3>Right of withdrawal</h3>
                        <p>You have the right to withdraw from this contract within fourteen days
                            without giving any reason.</p>
                        <p>The withdrawal period is fourteen days from the day on which you or
                            a
                            third party named by you, who is not the carrier, took possession of the
                            last goods.</p>
                        <p>To exercise your right of withdrawal, you must inform us
                            (Becker &amp; Karsten UG (haftungsbeschr&auml;nkt), Sandhauser Str. 107,
                            13505
                            Berlin, Germany, Tel.: +49 30 609851960, Email:
                            wir@beckerundkarsten.de)
                            by means of a clear declaration (e.g. a letter sent by post
                            or an email) of your decision to withdraw from this contract.
                            You may use the attached
                            model withdrawal form for this purpose, although it is not mandatory.</p>
                        <p>You may also exercise your right of withdrawal online on the website at the
                            web address <a href="https://widerruf.beckerundkarsten.de"
                                           target="_blank">https://widerruf.beckerundkarsten.de</a>.
                            If you use this online feature, we will promptly send you an acknowledgement
                            of receipt on a durable medium (e.g. by email), including information about
                            the content of the
                            withdrawal declaration as well as the date and time of its
                            receipt.</p>
                        <p>To meet the withdrawal deadline, it is sufficient for you to send your
                            notification concerning the exercise of the right of withdrawal before the
                            withdrawal period has expired.</p>
                        <h3>Consequences of withdrawal</h3>
                        <p>If you withdraw from this contract, we shall reimburse to you all payments
                            received from you, including the costs of delivery (with the
                            exception
                            of the additional costs arising from your choice of a type of delivery
                            other than the least expensive type of standard delivery offered by us),
                            without undue delay and at the latest
                            within fourteen days from the day on which we receive
                            notification of your withdrawal from this contract.
                            For this reimbursement, we will use the same means of payment that
                            you
                            used for the original transaction, unless expressly agreed otherwise
                            with you; in no case
                            will you be charged any fees for this reimbursement. We may withhold
                            reimbursement until we have received the goods back
                            or until you have supplied evidence of having sent back the goods,
                            whichever is the earlier.</p>
                        <p>You shall send back or hand over the goods to us without undue delay and in
                            any event no later than fourteen days from the day on which you notify us of
                            the withdrawal from this
                            contract.
                            The deadline is met if you send back the goods before the period of fourteen
                            days
                            has expired.</p>
                        <p>You shall bear the direct cost of returning the goods.</p>
                        <p>You are only liable for any diminished value of the goods
                            resulting from the handling of them other than what is necessary to
                            establish the nature, characteristics and functioning of the
                            goods.</p>
                        <h3>Exclusion or early expiry of the right of withdrawal</h3>
                        <p>The right of withdrawal does not exist for contracts for the supply of
                            goods
                            that are not prefabricated and for the production of which an individual
                            selection or determination by the consumer is decisive, or which
                            are clearly tailored to the consumer's personal
                            requirements.</p>
                        <p>The right of withdrawal does not apply to consumers who, at the time of
                            concluding the contract, do not belong to any member state of the European
                            Union and whose sole place of residence and delivery address at the time
                            of concluding the contract are outside the European Union.</p>
                        <h2>B. Cancellation Form</h2>
                        <p>If you wish to withdraw from the contract, please complete this
                            form and send it back.</p>
                        <p>To</p>
                        <p>Becker &amp; Karsten UG (haftungsbeschr&auml;nkt)<br/>
                            Sandhauser Str. 107<br/>
                            13505 Berlin<br/>
                            Germany</p>
                        <p>Email: wir@beckerundkarsten.de</p>
                        <p>I/we (*) hereby withdraw from the contract concluded by me/us (*)
                            for the purchase of the following goods (*) / the provision of the
                            following service (*)</p>
                        <p>_______________________________________________________</p>
                        <p>_______________________________________________________</p>
                        <p>Ordered on (*) ____________ / received on (*) __________________</p>
                        <p>________________________________________________________<br/>
                            Name of consumer(s)</p>
                        <p>________________________________________________________<br/>
                            Address of consumer(s)</p>
                        <p>________________________________________________________<br/>
                            Signature of consumer(s) (only if this form is notified on paper)</p>
                        <p>_________________________<br/>
                            Date</p>
                        <p>(*) Delete as appropriate</p>
                    </div>
                </ContentWrapper>
            </article>
        </React.Fragment>
    );
};

export default Tos;



// WEBPACK FOOTER //
// ./src/components/en/Tos.js